import { useSelector } from 'react-redux';
import { staticComponentValueConverter } from '../StaticComponentValues';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import { useMemo } from 'react';

function ForgotPassword_2({ item }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);
  const customization = staticComponentValueConverter(item?.customization);
  const generalStyle = useSelector(state => state.themeSlice?.branding?.generalStyle);
  const sixthThemeColor = generalStyle?.sixthThemeColor ?? 'black'; //Input yazı rengi
  const iconFilter = useMemo(() => HexToHueConverter(sixthThemeColor), []);

  return (
    <div className="h-full w-full overflow-hidden pointer-events-auto">
      <div className="overflow-auto" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
        <div
          style={{
            fontSize: customization?.textSize,
            fontWeight: customization?.textWeight,
            paddingTop: staticValues[30],
            paddingLeft: staticValues[10],
            paddingRight: staticValues[10],
            paddingBottom: staticValues[10],

            color: customization?.textColor,
            textAlign:
              customization?.textAlignment === 'center'
                ? 'center'
                : customization?.textAlignment === 'right'
                ? 'right'
                : 'left',
          }}
        >
          {item?.data?.text || 'Şifremi unuttum'}
        </div>
        <div
          style={{
            fontSize: staticValues[12],
            color: 'var(--secondaryThemeColor)',
            paddingLeft: staticValues[10],
            paddingRight: staticValues[10],
            textAlign:
              customization?.textAlignment === 'center'
                ? 'center'
                : customization?.textAlignment === 'right'
                ? 'right'
                : 'left',
          }}
        >
          {item?.data?.description ||
            'Lütfen mail adresinizi giriniz. E-posta yoluyla yeni bir şifre oluşturmak için bir bağlantı alacaksınız.'}
        </div>
        <div
          className="form"
          style={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 5,
            padding: staticValues[10],
          }}
        >
          <div
            style={{
              fontSize: staticValues[12],
              fontWeight: 600,
              textAlign: 'left',
              color: 'var(--secondaryThemeColor)',
            }}
          >
            Email
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'center',
              alignItems: 'center',
              borderRadius: 10,
              backgroundColor: 'var(--fifthThemeColor)',
            }}
          >
            <div
              style={{
                paddingRight: staticValues[15],
                paddingLeft: staticValues[10],
              }}
            >
              <img
                style={{
                  filter: iconFilter,
                }}
                width={20}
                height={20}
                src={customization?.emailIcon}
              />
            </div>
            <div style={{ flex: 1 }}>
              <input
                type={'text'}
                style={{
                  paddingTop: staticValues[10],
                  paddingRight: staticValues[10],
                  paddingBottom: staticValues[10],
                  paddingLeft: 0,
                  width: '100%',
                  color: '#424242',
                  borderRadius: 10,
                  fontSize: staticValues[12],
                  backgroundColor: 'var(--fifthThemeColor)',
                }}
                placeholder="Email"
              />
            </div>
          </div>

          <div
            style={{
              backgroundColor: customization?.buttonColor,
              color: customization?.buttonTextColor,
              borderRadius: 10,
              padding: staticValues[10],
              fontSize: staticValues[14],
              marginTop: staticValues[25],
            }}
          >
            Gönder
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgotPassword_2;
